import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-hidden"]
const _hoisted_2 = {
  key: 0,
  class: "badge__label"
}

import { computed } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'Badge',
  props: {
    label: {},
    colorName: {},
    color: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v6453d8fe": (_ctx.color)
}))

const props = __props;
const hasLabel = computed(() => {
  return props.label != undefined;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass([
      'badge',
      [__props.colorName ? `badge--${__props.colorName}` : ''],
      { 'badge--has-label': hasLabel.value },
    ]),
    "aria-hidden": hasLabel.value
  }, [
    (hasLabel.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})